import React from 'react'
import { Container, Imagem } from './Styled'
import imagemMobile from 'images/pos-cnu-2025/cnu-mobile.png'

export default function ImagemMobile () {

	return (
		<Container>
			<Imagem src={imagemMobile} />
		</Container>
	)
}
